import { z } from "zod";
import {
  PASSWORD_REQUIRED,
  PASSWORD_TOO_LONG,
  PASSWORD_TOO_SHORT,
  PASSWORDS_DO_NOT_MATCH,
} from "@/constants/forms";

export const UpdatePasswordSchema = z
  .object({
    password: z
      .string()
      .min(6, PASSWORD_TOO_SHORT)
      .max(20, PASSWORD_TOO_LONG)
      .nonempty(PASSWORD_REQUIRED),
    confirmPassword: z
      .string()
      .min(6, PASSWORD_TOO_SHORT)
      .max(20, PASSWORD_TOO_LONG)
      .nonempty(PASSWORD_REQUIRED),
  })
  .superRefine((val, ctx) => {
    if (val.password !== val.confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: PASSWORDS_DO_NOT_MATCH,
        path: ["confirmPassword"],
      });
    }
  });

export type UpdatePasswordType = z.infer<typeof UpdatePasswordSchema>;
